export default __webpack_public_path__ + "static/media/Tillage.97a1f469.jpg";